import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  selectedSurvey as survey,
  surveys as allSurveys,
  setSelectedSurvey,
  setSelectedIndicator,
} from '../../store/slices/modelSurfaceSlice';
import store from '../../store/store';

export default function SurveyDropDown() {
  const selectedSurvey = useSelector(survey);
  const surveys = useSelector(allSurveys);

  useEffect(() => {
    if (Object.keys(surveys).length) {
      store.dispatch(setSelectedSurvey(surveys[0]));
    }
  }, [surveys]);

  //When selectedSurvey chnages, update url slug
  useEffect(() => {
    if (selectedSurvey.slug) {
      window.location.hash = `survey=${selectedSurvey.slug}`;
    } else {
      window.location.hash = `survey=all_countries`;
    }
  }, [selectedSurvey]);

  function handleSurveyChange(e) {
    if (e.target.value === 'all_countries') {
      store.dispatch(setSelectedSurvey({ name: 'all_countries' }));
      return;
    }
    let surveyObj = surveys.find((survey) => survey.name === e.target.value);
    store.dispatch(setSelectedSurvey(surveyObj));
    store.dispatch(setSelectedIndicator({ Label: 'all_indicators' }));
  }

  return (
    <div>
      <label className='country-label'>Select a Survey</label>
      <div className='slate styled-select'>
        <select className='selection' value={selectedSurvey.name} onChange={handleSurveyChange}>
          <option value='all_countries'>All Countries</option>
          {surveys.length &&
            surveys.map((survey, i) => {
              return (
                <option value={survey.name} key={`${survey.name}_${i}`}>
                  {survey.name}
                </option>
              );
            })}
        </select>
      </div>
    </div>
  );
}
